export default class IncreaseNumbers {
	static init() {
        document.addEventListener('bless', () => {

			const animationDuration = 1500;
			const frameDuration = 1000 / 60;
			const totalFrames = Math.round( animationDuration / frameDuration );
			const easeOutQuad = t => t * ( 2 - t );

			const animateCountUp = el => {
				let frame = 0;
				const countTo = parseInt( el.innerHTML, 10 );

				const counter = setInterval( () => {

					frame++;

					const progress = easeOutQuad( frame / totalFrames );
					const currentCount = Math.round( countTo * progress );

					if ( parseInt( el.innerHTML, 10 ) !== currentCount ) {
						el.innerHTML = currentCount;
					}

					if ( frame === totalFrames ) {
						clearInterval( counter );
					}
				}, frameDuration );
			};

			const runAnimations = () => {
				const countupEls = document.querySelectorAll( '.countup' );
				countupEls.forEach( animateCountUp );
			};

			const target = document.querySelector('[data-target="increase-numbers"]');

			if (!target) {
				return;
			}

			function handleIntersection(payload) {
				if (payload[0].isIntersecting) {
					runAnimations();
				}
			}

			const observer = new IntersectionObserver(handleIntersection);

			observer.observe(target);
		});
    }
}


